exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/cloud-infrastructure/cloud-infrastructure.component.css
// module id = ../../../../../src/app/cloud-infrastructure/cloud-infrastructure.component.css
// module chunks = main